import React, { useEffect, useState } from 'react';
import { quickTransferOrders } from '../../../actions/qtActions';
import DriverLookupInput from '../DriverLookupInput';

import { 
    TextField, Button, Checkbox, Select, MenuItem
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useAlert } from '../../../utilities/hooks';
import { showAlertSnackbar } from '../../../reducers/uiSlice';
import FullscreenLoading from '../../../components/Common/FullscreenLoading';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { assignServicePoint, getDriverServicePoint } from '../../../actions/dropOffActions';
import { getUserPreference, handleCapitalize } from '../../../utilities/common';

const BasicTransfer = (props) => {
    const {classes, dispatch, userCity, searchList, driverListTemp, branches} = props;
    const {t} = useTranslation('quickTransfer');
    const alertDialog = useAlert();

    const servicePointList = useSelector(state => state.servicePoint.getServicePoint);
    const userPref = getUserPreference();

    const [transferDriverName, setTransferDriverName] = useState('...');
    const [transferDriverId, setTransferDriverId] = useState('');
    const [newBatchToggle, setNewBatchToggle] = useState(false);
    const [tnos, setTnos] = useState([]);
    const [tnosRaw, setTnosRaw] = useState('');
    const [tnosCount, setTnosCount] = useState(0);
    const [subBatch, setSubBatch] = useState('');
    const [warehouse, setWarehouse] = useState(userCity);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [lastDropOff, setLastDropOff] = useState('');
    const [servicePointId, setServicePointId] = useState('');

    const handleTnosInput = (event) => {
        let tnosArray = event.target.value.split('\n');
        let tnosCurr = [];
        let tnosCurrCount = 0;

        tnosArray.forEach((element) => {
            if (element) {
                tnosCurr.push(element);
                tnosCurrCount++;
            }
        });

        setTnosRaw(event.target.value);
        setTnos(tnosCurr);
        setTnosCount(tnosCurrCount);
    };

    const handleReset = () => {
        setTransferDriverName('...');
        setTransferDriverId('');
        setNewBatchToggle(false);
        setTnos([]);
        setTnosRaw('');
        setTnosCount(0);
        setSubBatch('');
        setWarehouse(userCity);
        setSubmitLoading(false);
    }

    const checkSubmitArgs = () => {
        let valid = true;

        if (tnos.length <= 0) {
            valid = false;
        }
        if (newBatchToggle === false && transferDriverId === '') {
            valid = false;
        }

        return valid;
    }

    const handleSubmit = async () => {
        if (checkSubmitArgs()) {
            try {
                setSubmitLoading(true);
                let params = {
                    tnos: tnos.toString(),
                    driver_id: transferDriverId,
                    assign_to_sub_batch: newBatchToggle,
                    sub_batch_no: subBatch,
                    warehouse: warehouse,
                    operator: userPref.username
                }
                let res = await dispatch(quickTransferOrders(params));
                if (res.order_not_found.length === 0) {
                    dispatch(showAlertSnackbar({title: t('title_quick_transfer'),
                        message: `${t('input')} ${tnos.length} ${t('order')}，${t('transfer')} ${res.success.length} ${t('order')}`,
                        type: 'success'
                    }));

                    if (newBatchToggle) {
                        alertDialog.addAlertDialog(`${t('sub_batch_number')}:`, res.sub_batch_no);
                        alertDialog.showAlert();
                    }
                } else {
                    dispatch(showAlertSnackbar({title: t('title_quick_transfer'),
                        message: `${t('input')} ${tnos.length} ${t('order')}，${t('transfer')} ${res.success.length} ${t('order')}`,
                        type: 'warning'
                    }));

                    if (newBatchToggle) {
                        alertDialog.addAlertDialog(`${t('sub_batch_number')}: ${res.sub_batch_no} ${t('failed')}`, res.order_not_found);
                    } else {
                        alertDialog.addAlertDialog(`${t('failed')}`, res.order_not_found);
                    }
                    alertDialog.showAlert();
                }
                if(servicePointId) {
                    dispatch(assignServicePoint(transferDriverId, servicePointId));
                }
            } catch (error) {
                let msg;

                switch (error.message) {
                    case "Failed to generate Sub Batch Number":
                        msg = t('sub_batch_failed');
                        break;
                    case "Failed to transfer packages":
                        msg = t('transfer_failed');
                        break;
                    case "sub_batch number not valid":
                        msg = t('sub_batch_invalid');
                        break;
                    default:
                        msg = t('import_correct_info');
                        break;
                }
                
                dispatch(showAlertSnackbar({title: t('title_quick_transfer'), 
                    message: msg,
                    type: 'error'
                }));
            } finally {
                setSubmitLoading(false);
            }
        }
    };

    useEffect(() => {
        if(transferDriverId) {
            dispatch(getDriverServicePoint(transferDriverId))
            .then((res) => {
                setLastDropOff(res.name);
            })
            .catch(() => {
                setLastDropOff(t('not_set_yet'));
            })
        }
    }, [transferDriverId])

    useEffect(() => {
        setServicePointId('');
    }, [])

    return (
        <div>
            <div className={classes.batchesStyle}>
                <div className={classes.titleStyle}>{t('input_ant_parcels')}</div>
                <TextField multiline className={classes.textfieldBatchStyle}
                    rows={10}
                    autoFocus={true}
                    variant="outlined"
                    value={tnosRaw}
                    onChange={handleTnosInput}
                />
                <div className={classes.titleStyle}
                    style={{ textAlign: 'right' }}
                >
                    {tnosCount}
                </div>
            </div>

            <div className={classes.driverStyle}>
                <DriverLookupInput classes={classes}
                    userCity={userCity}
                    searchList={searchList}
                    driverListTemp={driverListTemp}
                    transferDriverName={transferDriverName}
                    setTransferDriverName={setTransferDriverName}
                    transferDriverId={transferDriverId}
                    setTransferDriverId={setTransferDriverId}
                />
            </div>

            <div style={{ display: 'flex' }}>
                <Checkbox style={{ marginLeft: -10 }}
                    checked={newBatchToggle}
                    onChange={ (e) => {setNewBatchToggle(e.target.checked)} }
                />
                <div className={classes.titleStyle} style={{ paddingTop: 9 }}>
                    {t('move_sub_batch')}
                </div>
            </div>
            
            <div>
                <TextField className={classes.textfieldBatchStyle}
                    variant="outlined"
                    size="small"
                    disabled={!newBatchToggle}
                    value={subBatch}
                    label={t('sub_batch_number')}
                    onChange={(e) => { setSubBatch(handleCapitalize(e.target.value)) }}
                />
            </div>

            <div>
                <Select style={{ marginTop: 10, marginLeft: 5, width: '98%' }}
                    disabled={!newBatchToggle}
                    value={warehouse}
                    onChange={ (e) => {setWarehouse(e.target.value)} }
                >
                    {(branches).map((branch, index) => {
                        return <MenuItem key={index} value={branch.id}>{branch.name}</MenuItem>
                    })}
                </Select>
            </div>
            {
                servicePointList &&
                <Autocomplete
                    options={servicePointList}
                    getOptionLabel={(option) => option.name}
                    // getOptionDisabled={(option) => option.total_dropoff >= option.storage_space}
                    style={{ marginTop: 30 }}
                    renderInput={(params) => (
                        <TextField {...params} label={t("destined_drop_off_optional")} variant="outlined" />
                    )}
                    onChange={(event, newValue) => {
                        if(!newValue) {
                            setServicePointId('');
                            return;
                        }
                        setServicePointId(newValue.id);
                    }}
                    renderOption={(option) => (
                        <div style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
                            <div>{option.name}</div>
                            <div
                                style={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    maxWidth: 300
                                }}                                
                            >
                                {option.company}
                            </div>
                            {
                                option.id !== '-1' &&
                                <div>{option.total_dropoff}/{option.storage_space}</div>
                            }
                        </div>
                    )}
                />
            }
            <div style={{fontSize: 13, color: '#fff', marginTop: 6}}>
                {t('last_location') + lastDropOff}
            </div>
            <div style={{marginTop: 20, display: 'flex', justifyContent: 'space-between'}}> 
                <Button className={classes.resetStyle}
                    variant='contained' 
                    color='primary'
                    onClick={handleReset}
                >
                    {t('common:reset')}
                </Button>

                <Button className={classes.submitStyle}
                    variant='contained' 
                    color='secondary'
                    onClick={handleSubmit}
                    disabled={(transferDriverName === '...' && transferDriverId) || (!newBatchToggle && !transferDriverId)}
                >
                    {t('common:submit')}
                </Button>
            </div>

            <FullscreenLoading open={submitLoading}/>
        </div>
    );
}

export default BasicTransfer;
